export const groupBy = (list: any[], keyGetter: (item: any) => {}) => {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
};

export function chunkArray<T>(arr: T[], chunkSize: number): T[][] {
  const chunks = [];

  for (let index = 0; index < arr.length; index += chunkSize) {
    const chunk = arr.slice(index, index + chunkSize);
    chunks.push(chunk);
  }

  return chunks;
}

export function flattenArrays<T>(arrayOfArrays: T[][]): T[] {
  const merged = ([] as T[]).concat.apply([], arrayOfArrays);
  return merged;
}
